// Features.jsx

import "../../styles/garage/garage-main.css";

import invoice from "../../assets/features/invoice.png";
import finance from "../../assets/features/money.svg";
import workOrder from "../../assets/features/work-orders.png";
import staff from "../../assets/features/staff.png";

const features = [
    {
        number: "01",
        title: "Invoices, made simple.",
        text: "Create professional invoices in seconds, keep your records organized, and make it easier to keep track of every customer payment.",
        image: invoice,
        imageAlt: "Invoice management illustration",
    },
    {
        number: "02",
        title: "Know where your money goes.",
        text: "Track income, expenses, outstanding payments and your garage's financial activity from one simple dashboard.",
        image: finance,
        imageAlt: "Financial tracking illustration",
    },
    {
        number: "03",
        title: "Work orders that keep work moving.",
        text: "Prepare detailed work orders, assign them to your team and keep every repair organized from start to finish.",
        image: workOrder,
        imageAlt: "Work order illustration",
    },
    {
        number: "04",
        title: "Your team, all in one place.",
        text: "Add staff, manage their roles and keep your entire garage team organized without relying on spreadsheets or paperwork.",
        image: staff,
        imageAlt: "Staff management illustration",
    },
];

export default function Features() {
    return (
        <section className="garage-features" id="features">

            <div className="features-heading">

               

                <h2>
                    Built for the way
                    <br />
                    <span>your garage works.</span>
                </h2>

            </div>

            <div className="features-grid">

                {features.map((feature) => (
                    <article
                        className="feature-card"
                        key={feature.number}
                    >

                        <div className="feature-visual">
                            <img
                                src={feature.image}
                                alt={feature.imageAlt}
                            />
                        </div>

                        <div className="feature-card-content">

                            <span className="feature-number">
                                {feature.number}
                            </span>

                            <h3>{feature.title}</h3>

                            <p>{feature.text}</p>

                        </div>

                    </article>
                ))}

            </div>

        </section>
    );
}